import { render } from "./confirmaTerms.vue?vue&type=template&id=df44bc5c"
import script from "./confirmaTerms.vue?vue&type=script&lang=js"
export * from "./confirmaTerms.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__